import es from 'vuetify/es5/locale/es'

export default {
    ...es,

    tvsm: {
        loginfailcode: {
            1: 'Este usuario no está registrado.',
            2: 'Autenticación de usuario fallida.'
        },
        next: 'próximo',
        language: 'Español',
        gendershort: { 1: 'M', 2: 'F' },
        gender: { 1: 'Male', 2: 'Female' },
        usertype: {1:'Admin', 2:'Physician', 3:'Staff'},
        pattype: {1:'New Born', 2:'Pediatric', 3:'Adult'},
        menu: {
            tvsmList: 'TVSM List',
            history: 'Historia',
            videoCallHistory: 'Videollamada',
            videoCallReservationHistory: 'Reserva',

            management: 'Gestión',
            group: 'Grupo',
            user: 'Usuario',
            patient: 'Paciente',
            device: 'Aparato',
            realtime: 'Tiempo Real'
        },
        header: {
            seq: 'Seq.',
            status: 'Estado',
            group: 'Grupo',
            deviceName: 'Aparato nombre',
            patientNameAndId: 'Paciente ID/nombre',
            patientStatus: 'Paciente Estado',
            birthday: 'Cumpleaños',
            ageSexBloodType: 'Edad/Sexo/Tipo de sangre',
            heightWeight: 'Altura/Peso',
            detail: 'Detalle',
            userName: 'Médico',
            patientName: 'Paciente',
            startTime: 'Comienzo',
            endTime: 'Fin',
            duration: 'Duración',
            requestTime: 'Solicitado',
            requestType: 'Escribe',
            reserveTime: 'Reservado',
            videocall: 'Videollamada'
        },
        alert: {
            noConnection: 'Sin conexión.'
        }
    },

    common: {
        search: 'BUSCAR',
        login: 'Acceso',
        logout: 'Cerrar sesión',
        cancel: 'Cancelar',
        submit: 'Enviar',
        updated: 'Actualizado',
        created: 'Creado',
        deleted: 'Eliminado',
        start: 'Comienzo',
        addGroup: 'Añadir grupo',
        noMemo: 'No Memo',
        update: 'Editar',
        delete: 'Eliminar',
        memo: 'Memo',
        groupName: 'Nombre del grupo',
        confirmDelete: 'Eliminar grupo "{0}"?',
        editDelete: 'Editar/Eliminar',
        addPatient: 'Agregar paciente',
        ID: 'ID',
        name: 'Nombre',
        type: 'Escribe',
        age: 'Edad',
        sex: 'Sexo',
        bloodType: 'Tipo de sangre',
        height: 'Altura',
        weight: 'Peso',
        addUser: 'Agregar usuario',
        pacemaker: 'Marcapasos',
        phone: 'Teléfono',
        email: 'Email',
        remoteControl: 'Acceso remoto',
        modelName: 'Modelo',
        lastUpdated: 'Última actualización',
        requestType: {
            1: 'Normal',
            2: 'Emergencia'
        },

        menu: {
            account: 'Mi cuenta'
        }
    }
}